import api from '../api';

import { ParamsBodyListarFormaPagamentoPorCanalVenda, ParamsDataListarFormaPagamentoPorCanalVenda } from 'utils/typeServices';

type ParamsResponse = {
    Data: Array<ParamsDataListarFormaPagamentoPorCanalVenda>;
}

export const PostListarFormaPagamentoPorCanalVenda = async ({ token, body }: { token: string, body: ParamsBodyListarFormaPagamentoPorCanalVenda }) => {

    try {
        const { data } = await api.get<ParamsResponse>(`/v1/Pagamento/ListarFormaPagamentoPorCanalVenda/${body.CdCanalVenda}/${body.CdTipoCobranca}`, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data.Data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
